export default {
  path: '/relatorios-ipem',
  component: () => import('@/components/pages/IPEMReports/IPEMReports.vue')
}
